'use strict';

/**
 * @ngdoc directive
 * @name cloudBillingLegacyFrontend.directive:eaNavbar
 * @description
 * # eaNavbar
 */
angular.module('cloudBillingLegacyFrontend').directive('eaNavbar', function () {
    return {
      templateUrl: 'views/directive_ea_navbar.html',
      restrict: 'C',
      controller: 'EaNavbarCtrl',
      scope: {
        currentSession: '='
      }
    };
}).controller('EaNavbarCtrl', function($scope, $q, $eaBackend, $state, $rootScope, $eaBackendDataModeSelector, $eaSession2, $location, $busy, $controller, $modal, $timeout, $toolbar, $eaTeamManagement, $eaUserProfile, gravatarService, $eaConfig, $stateParams, $eaCspService, $window, $eaNotificationCenter) {
    var self = this;

  // inject mixins
  $.extend(self, $controller('SessionHelperCtrlMixin', {$scope: $scope, $eaBackendDataModeSelector: $eaBackendDataModeSelector, $eaSession2: $eaSession2, $state: $state }));
  $.extend(self, $controller('TeamsChooseTeamMixinCtrl', {$scope: $scope, $modal: $modal, $controller: $controller, $q: $q, $eaTeamManagement: $eaTeamManagement}));

  // define variables
  $scope.toolbarItems =   $toolbar.items;
  $scope.title = 'Cloud Billing';
  $scope.fullWidthHeader = true;

  function updateNavBarBasicMenu() {

    if ($scope.currentSession) {
      $eaUserProfile.load($scope.currentSession.DataToken).then(function (profile) {

        if ($scope.currentSession.isActAsSession()) {
          $toolbar.addItem('leaveActAs', 'Leave Act-As', 'fa-sign-out', null, true, $scope.leaveActAs, null);
        }

        // define the username
        var userName;
        if ($scope.currentSession.FirstName) { userName = $scope.currentSession.FirstName + ' '; } else { userName = ''; }
        if ($scope.currentSession.LastName) { userName = userName + $scope.currentSession.LastName; }
        if (!userName) { userName = $scope.currentSession.Contact; }

        // add the user item
        $toolbar.addItem('user', userName, 'img:' + gravatarService.url($scope.currentSession.Contact, { size: 20, default: 'mm'}), $scope.currentSession.Contact, true, null, 99);
        
        // The user must be at least part of one team otherwise we don't show the page
        if ($eaTeamManagement.isAdminInAtLeastOneTime(profile)) {
          $toolbar.addItem('user.manageTeams', 'Users', 'fa-user-plus', null, true, function() {
            $rootScope.visibleUserManagement = true;
          }, 20, 'user');
        }
                
        if ($eaTeamManagement.isAdminInAtLeastOneTime(profile)) {
          $toolbar.addItem('user.reportcenter', 'Reports', 'fa-file-chart-column', null, true, function () {

            if ($stateParams.teamid) {
              $window.location.href = '/cb1/app2/teams/' + $stateParams.teamid + '/apps/reportcenter';
            } else if ($location.path().indexOf('/csp') === 0) {
              $window.location.href = '/cb1/app2/teams/' + $stateParams.resellerId + '/apps/reportcenter';
            }
          }, 10, 'user');
        }

        if ($location.path().indexOf('/csp') === 0 && ($stateParams.teamid !== 'personal' || $stateParams.resellerId)) {

          $toolbar.addItem('user.divider2', 'DIVIDER', null, null, true, null, 28, 'user');        
          $toolbar.addItem('user.cloudconfigurator', 'IaaS Configurator', 'fa-cloud', null, true, function () {

            var localTeamIdIaaS = $stateParams.resellerId;
            if (!localTeamIdIaaS) {localTeamIdIaaS = $stateParams.teamid;}

            $window.location.href = '/cb1/app2/teams/' + localTeamIdIaaS + '/apps/cloudconfigurator';
          }, 29, 'user');
        }

        if ($eaConfig.getConfiguration().features && $eaConfig.getConfiguration().features.support && $location.path().indexOf('/csp') === 0) {          
          $toolbar.addItem('user.support', 'Contact Support', 'fa-support', null, true, 'https://mevodo-org.myfreshworks.com/login/auth/1671963070430?client_id=78368727158800390&redirect_uri=https%3A%2F%2Fcloudbilling.freshdesk.com%2Ffreshid%2Fcustomer_authorize_callback', 40, 'user');
        }
        
          $toolbar.addItem('user.divider', 'DIVIDER', null, null, true, null, 50, 'user');                

        if ($location.path().indexOf('/csp') === 0) {
          $toolbar.addItem('user.csp', 'My Spending Portal', 'fa-bar-chart', null, true, '/signin?csp=false', 55, 'user');
        }
        
        if ($scope.currentSession.hasCap('nv')) {          
          $toolbar.addItem('next.portal', 'Open new version', 'fa-code-fork', null, true, function () {
            $window.location.href = '/cloudbilling';
          }, 60, 'user');
        }

        if ($scope.currentSession.IdentityProvider === 'actAs') {
          $toolbar.addItem('user.leaveActAs', 'Leave Act-As', 'fa-sign-out', null, true, $scope.leaveActAs, 120, 'user');
        } else {
          // $toolbar.addItem('user.refreshSession', 'Refresh Session', 'fa-refresh', null, true, $scope.refreshSession, 100, 'user');
          // $toolbar.addItem('user.profile', 'Profile', 'fa-user', null, true, $scope.visitProfile, 110, 'user');
          $toolbar.addItem('user.signout', 'Sign Out', 'fa-power-off', null, true, $scope.signOut, 120, 'user');
        }

        // Notifications Panel operation
        if ($location.path().indexOf('/csp') === 0) {
          $toolbar.addItem('notificationsPane.General', '', 'fa-bell-o', 'Open the notifications panel', true, $scope.toggleNotificationsPanel);
        }
      });
    }
  }

  function adaptHeaderWidth() {
    if (($location.path() === '/') || ($location.path().indexOf('/imprint') === 0)) {
      $scope.fullWidthHeader = false;
    } else {
      $scope.fullWidthHeader = true;
    }
  }

  // handle toolbar updates
  $toolbar.onUpdate( function() {
    adaptHeaderWidth();
    $scope.toolbarItems = $toolbar.items;
  });

  // handle session updates
  $eaSession2.onUpdate(function() {
    updateNavBarBasicMenu();
  });

  $eaSession2.onDestroying(function() {
    updateNavBarBasicMenu();
  });

  $rootScope.$on('$stateChangeSuccess', function() {
    updateNavBarBasicMenu();
  });
  
  $scope.toggleNotificationsPanel = function () {
    if ($eaNotificationCenter.isOpen()) {
      $eaNotificationCenter.close();
    } else {
      $eaNotificationCenter.show();
    }
  };

  // Manages the mobile menu when the browser window is too small
  $scope.toggleMobileNavMenuClasses = '';
  $scope.toggleMobileNavMenu = function() {
    if ($scope.toggleMobileNavMenuClasses === 'open-nav') {
      $scope.toggleMobileNavMenuClasses = '';
    } else {
      $scope.toggleMobileNavMenuClasses = 'open-nav';
    }
  };

  // initialize the navbar
  updateNavBarBasicMenu();
});
